@if (label) {
<div class="label">
  <span>{{ label }}</span>
  @if (isRequired()) {
  <span class="required-asterisk">*</span>
  } @if (matTooltipLabel) {
  <mat-icon matTooltip="{{ matTooltipLabel }}">info</mat-icon>
  }
</div>
}
<mat-form-field appearance="outline">
  <input
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="placeholder || 'Введите адрес'"
    (blur)="onTouched()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
  >
    <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion">
      {{ suggestion.result }}
    </mat-option>
  </mat-autocomplete>

  @if (control.hasError('required') && control.touched) {
  <mat-error>Вы не ввели адрес</mat-error>
  } @if (control.hasError('notSelected') && control.touched) {
  <mat-error>Выберите адрес из списка</mat-error>
  }
</mat-form-field>
